module.exports = __webpack_public_path__ + "images/pages/sns_campaign_lp/balloon-2_9a29b9f24887ed05293d5f4aaa169d78.png";